import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { SecondaryCriteriaIcon } from "@common/secondaryCriteriaIcon";
import { Props } from "./types";
import { ToggleArrow } from "./toggleArrow";
import { Form } from "./form";
import styles from "./styles.scss";

function Criteria({
  criteria,
  type,
  isRequestPending,
  isOption = false,
  isCreating = false,
  cancel,
  remove,
  reset,
  edit,
  submit,
}: Props) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = React.useState(isCreating);

  return (
    <div
      className={classNames(styles.criteria, {
        [styles.open]: isOpen,
        [styles.option]: isOption,
      })}
    >
      <div className={styles.header} onClick={() => setIsOpen(!isOpen)}>
        <div className={styles.row}>
          <SecondaryCriteriaIcon type={criteria.type} className={styles.icon} />
          <p className={styles.name}>
            {criteria.name.length === 0
              ? t("secondaryCriteriaTemplate.form.name.defaultName")
              : criteria.name}
          </p>
        </div>
        <ToggleArrow className={styles.toggleIcon} />
      </div>
      {isOpen && (
        <div className={styles.form}>
          <Form
            formData={criteria}
            type={type}
            edit={edit}
            submit={submit}
            reset={reset}
            cancel={cancel}
            remove={remove}
            isCreating={isCreating}
            isOption={isOption}
            hasChanged={criteria.hasChanged}
            isRequestPending={isRequestPending}
          />
        </div>
      )}
    </div>
  );
}

export { Criteria };
